export default {
  setContracts(state, value) {
    state.contracts = value
  },

  setServiceRequests(state, value) {
    state.serviceRequests = value
  },
}
